import axios from 'axios';

const PREFIJO="/api/ApcMdCmr/";

export default {
    lista() {
        const dto={bdt1:true};
        return axios.post(`${PREFIJO}VmSlAmd`,dto);
    }
};
